<template>
  <footer class="foot">
    <div class="foot__inner">
      <div class="foot__mark">
        <span class="brand__mark" aria-hidden="true"></span>
        <span class="mono">MAKE IT LOOK REAL</span>
      </div>
      <p class="foot__note">
        A self-teaching lab in graphite portraiture. Every diagram on this page is
        original vector art drawn for the lesson it sits in — nothing here is a
        scan or a photograph.
      </p>
      <p class="foot__src mono">
        Method adapted from the classic North Light drawing curriculum popularised by
        Lee Hammond in <i>Draw Real People!</i> (1996). Techniques are described in our
        own words; no text or artwork from that book is reproduced here.
      </p>
      <a class="foot__top" href="#top">↑ Back to the top</a>
    </div>
  </footer>
</template>

<style scoped>
.foot {
  position: relative;
  z-index: 2;
  padding: 90px var(--gutter) 70px;
  border-top: 1px solid var(--edge-soft);
  background: linear-gradient(180deg, transparent, rgba(0, 0, 0, 0.5));
}
.foot__inner { max-width: 900px; margin: 0 auto; }
.foot__mark {
  display: flex;
  align-items: center;
  gap: 10px;
  color: var(--v4);
  margin-bottom: 22px;
}
.brand__mark {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: radial-gradient(circle at 32% 30%, var(--v5) 0 18%, var(--v3) 40%, var(--v1) 88%);
}
.foot__note { color: var(--text-dim); max-width: 58ch; }
.foot__src {
  color: var(--text-faint);
  font-size: 10px;
  letter-spacing: 0.1em;
  text-transform: none;
  line-height: 1.9;
  max-width: 70ch;
  margin-top: 26px;
}
.foot__top {
  display: inline-block;
  margin-top: 32px;
  font-family: var(--font-mono);
  font-size: 11px;
  letter-spacing: 0.18em;
}
</style>
